import React, { useState, useEffect } from 'react'
import { isEmpty } from 'lodash'

import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  Spinner
} from 'reactstrap'

// Formik Validation
import * as Yup from 'yup'
import { useFormik } from 'formik'

//redux
import { useSelector, useDispatch } from 'react-redux'

import avatar from '../../assets/images/users/avatar-1.jpg'
// actions
import { editProfile, resetProfileFlag } from '../../slices/thunks'
import { createSelector } from 'reselect'
import { toast } from 'react-toastify'
import { APIClient } from '../../helpers/api_helper'

const apiClient = new APIClient()

const UserProfile = () => {
  const dispatch: any = useDispatch()

  const [email, setemail] = useState('admin@socialboothturkey.com')
  const [idx, setidx] = useState('1')
  const [userName, setUserName] = useState('Admin')

  // Password change state
  const [changingPassword, setChangingPassword] = useState(false)
  const [passwordSuccess, setPasswordSuccess] = useState('')
  const [passwordError, setPasswordError] = useState('')

  const selectLayoutState = (state: any) => state.Profile
  const userprofileData = createSelector(selectLayoutState, (state: any) => ({
    user: state.user,
    success: state.success,
    error: state.error
  }))
  const { user, success, error } = useSelector(userprofileData)

  useEffect(() => {
    const storedUser = sessionStorage.getItem('authUser')
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser)
      const profileData = parsedUser?.data ?? parsedUser

      if (!isEmpty(user)) {
        if (!parsedUser.data) {
          parsedUser.data = {}
        }
        parsedUser.data.first_name = user.fullName || user.first_name || parsedUser.data.first_name
        parsedUser.data.email = user.email || parsedUser.data.email
        sessionStorage.setItem('authUser', JSON.stringify(parsedUser))
      }

      const resolvedFirstName =
        profileData?.first_name || profileData?.fullName || profileData?.fullname || profileData?.name || 'Admin'
      const resolvedEmail = profileData?.email || 'admin@socialboothturkey.com'
      const resolvedId = profileData?._id || profileData?.id || '1'

      setUserName(resolvedFirstName)
      setemail(resolvedEmail)
      setidx(resolvedId)

      setTimeout(() => {
        return dispatch(resetProfileFlag())
      }, 3000)
    } else {
      setUserName('Admin')
      setemail('admin@socialboothturkey.com')
      setidx('1')
    }
  }, [dispatch, user])

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: userName || 'Admin',
      idx: idx || ''
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required('Please Enter Your UserName')
    }),
    onSubmit: (values) => {
      dispatch(editProfile(values))
    }
  })

  const passwordFormik: any = useFormik({
    initialValues: {
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    },
    validationSchema: Yup.object({
      currentPassword: Yup.string().required('Please enter your current password'),
      newPassword: Yup.string()
        .min(6, 'Password must be at least 6 characters')
        .required('Please enter your new password'),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword')], 'Passwords do not match')
        .required('Please confirm your new password')
    }),
    onSubmit: async (values, { resetForm }) => {
      setChangingPassword(true)
      setPasswordSuccess('')
      setPasswordError('')
      try {
        const res: any = await apiClient.put(`/api/v1/users/change-password/${idx}`, {
          currentPassword: values.currentPassword,
          newPassword: values.newPassword
        })
        const body = res?.data ?? res
        if (body.success) {
          setPasswordSuccess('Password changed successfully!')
          toast.success('Password changed successfully!')
          resetForm()
        } else {
          setPasswordError(body.error || 'Failed to change password')
        }
      } catch (err: any) {
        setPasswordError(typeof err === 'string' ? err : err?.error || 'Failed to change password')
      } finally {
        setChangingPassword(false)
      }
    }
  })

  document.title = 'Profile | SocialBooth - Admin Dashboard'
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Row>
            <Col lg='12'>
              {error && error ? <Alert color='danger'>{error}</Alert> : null}
              {success ? <Alert color='success'>Username Updated To {userName}</Alert> : null}

              <Card>
                <CardBody>
                  <div className='d-flex'>
                    <div className='mx-3'>
                      <img src={avatar} alt='' className='avatar-md rounded-circle img-thumbnail' />
                    </div>
                    <div className='flex-grow-1 align-self-center'>
                      <div className='text-muted'>
                        <h5>{userName || 'Admin'}</h5>
                        <p className='mb-1'>Email : {email}</p>
                        <p className='mb-0'>Id : #{idx}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <h4 className='card-title mb-4'>Change User Name</h4>
              <Card>
                <CardBody>
                  <Form
                    className='form-horizontal'
                    onSubmit={(e) => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <div className='form-group'>
                      <Label className='form-label'>User Name</Label>
                      <Input
                        name='first_name'
                        className='form-control'
                        placeholder='Enter User Name'
                        type='text'
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.first_name || ''}
                        invalid={
                          validation.touched.first_name && validation.errors.first_name ? true : false
                        }
                      />
                      {validation.touched.first_name && validation.errors.first_name ? (
                        <FormFeedback type='invalid'>{validation.errors.first_name}</FormFeedback>
                      ) : null}
                      <Input name='idx' value={idx} type='hidden' />
                    </div>
                    <div className='text-center mt-4'>
                      <Button type='submit' color='primary'>
                        Update User Name
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>

            <Col lg={6}>
              <h4 className='card-title mb-4'>Change Password</h4>
              <Card>
                <CardBody>
                  {passwordSuccess && <Alert color='success'>{passwordSuccess}</Alert>}
                  {passwordError && <Alert color='danger'>{passwordError}</Alert>}
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault()
                      passwordFormik.handleSubmit()
                      return false
                    }}
                  >
                    <div className='mb-3'>
                      <Label className='form-label'>Current Password</Label>
                      <Input
                        name='currentPassword'
                        type='password'
                        placeholder='Enter current password'
                        onChange={passwordFormik.handleChange}
                        onBlur={passwordFormik.handleBlur}
                        value={passwordFormik.values.currentPassword}
                        invalid={
                          passwordFormik.touched.currentPassword && passwordFormik.errors.currentPassword
                            ? true
                            : false
                        }
                      />
                      {passwordFormik.touched.currentPassword && passwordFormik.errors.currentPassword ? (
                        <FormFeedback type='invalid'>{passwordFormik.errors.currentPassword}</FormFeedback>
                      ) : null}
                    </div>
                    <div className='mb-3'>
                      <Label className='form-label'>New Password</Label>
                      <Input
                        name='newPassword'
                        type='password'
                        placeholder='Enter new password'
                        onChange={passwordFormik.handleChange}
                        onBlur={passwordFormik.handleBlur}
                        value={passwordFormik.values.newPassword}
                        invalid={
                          passwordFormik.touched.newPassword && passwordFormik.errors.newPassword
                            ? true
                            : false
                        }
                      />
                      {passwordFormik.touched.newPassword && passwordFormik.errors.newPassword ? (
                        <FormFeedback type='invalid'>{passwordFormik.errors.newPassword}</FormFeedback>
                      ) : null}
                    </div>
                    <div className='mb-3'>
                      <Label className='form-label'>Confirm New Password</Label>
                      <Input
                        name='confirmPassword'
                        type='password'
                        placeholder='Confirm new password'
                        onChange={passwordFormik.handleChange}
                        onBlur={passwordFormik.handleBlur}
                        value={passwordFormik.values.confirmPassword}
                        invalid={
                          passwordFormik.touched.confirmPassword && passwordFormik.errors.confirmPassword
                            ? true
                            : false
                        }
                      />
                      {passwordFormik.touched.confirmPassword && passwordFormik.errors.confirmPassword ? (
                        <FormFeedback type='invalid'>{passwordFormik.errors.confirmPassword}</FormFeedback>
                      ) : null}
                    </div>
                    <div className='text-center mt-4'>
                      <Button type='submit' color='danger' disabled={changingPassword}>
                        {changingPassword && <Spinner size='sm' className='me-2' />}
                        Change Password
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UserProfile
